import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { getAuth } from "@firebase/auth";
import user_model from "@iscr/models/user_model";
export function useLogUserLoggedIn() {
    useEffect(() => {
        let first = true;
        return onAuthStateChanged(getAuth(), user => {
            if (first) {
                // The app is just starting up, and we're finding out if the user already had a session. This is NOT
                // indicative of log in/out, just resuming the current user state (or lack of).
                first = false;
            }
            else if (user) {
                // We could just log it right here, but this keeps the user_login/out in the same place
                user_model.onUserLoggedIn(user).catch( /*ignore*/);
            }
        });
    }, []);
    return null;
}
